import { useQuery } from 'react-query';
import { queryAllCommerciaux } from './useCommerciaux.query';
import { AllCommercialRequestParams, UseCommerciauxResponse } from './useCommerciaux.types';

export const ALL_COMMERCIAUX_QUERY_KEY = 'ALL_COMMERCIAUX';

export const useCommerciaux = (params: AllCommercialRequestParams) => {
  return useQuery<UseCommerciauxResponse, Error>(
    [ALL_COMMERCIAUX_QUERY_KEY, params],
    () => queryAllCommerciaux(params),
    {
      retry: false,
    }
  );
};
